import { BookingBookingPayload, BookingFeature, isDeskFeature } from '../../../services/booking/types'
import { dateToNumber } from '../utils/utils'

export interface OccupancyResult {
  booked: number
  total: number
  percentage: number
  zoneApplied: boolean
}

export function calculateOccupancy(
  bookings: BookingBookingPayload[],
  features: BookingFeature[],
  viewingDate: Date,
  zoneId?: number
): OccupancyResult {
  let desks = features.filter(isDeskFeature)
  let zoneApplied = false

  if (zoneId) {
    const desksInZone = desks.filter(d => d.zone?.id === zoneId)
    if (desksInZone.length > 0) {
      desks = desksInZone
      zoneApplied = true
    }
  }

  const total = desks.length

  if (total === 0) {
    return { booked: 0, total: 0, percentage: 0, zoneApplied }
  }

  const viewingDateNum = dateToNumber(viewingDate)
  const deskIds = new Set(desks.map(d => d.id))
  const bookedDeskIds = new Set(
    bookings
      .filter(b => deskIds.has(b.featureId) && dateToNumber(b.fromDate) === viewingDateNum)
      .map(b => b.featureId)
  )

  const booked = bookedDeskIds.size
  const percentage = Math.round((booked / total) * 100)

  return { booked, total, percentage, zoneApplied }
}
